import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10 text-center">
          <span className="text-xs font-semibold text-accent-500 uppercase tracking-wider">📚 INDEX</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-2">主题索引</h2>
          <p className="text-sm text-foreground-500 mt-1">按风格快速定位，发现更多心仪漫画</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {indexData.map((item, idx) => (
            <a
              key={idx}
              href="#"
              className="bg-background-50 rounded-2xl p-5 text-center hover:bg-background-200/60 transition-colors duration-200 cursor-pointer no-underline block group"
            >
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-200">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
              <p className="text-[11px] text-foreground-500 mb-1">{item.count}</p>
              <p className="text-[11px] text-foreground-400">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}